module.exports = __webpack_public_path__ + "img/ak.d080270b.webp";